/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AnneeFormationSuivieIfapmeFichierGridDto
 */
export interface AnneeFormationSuivieIfapmeFichierGridDto {
    /**
     * 
     * @type {number}
     * @memberof AnneeFormationSuivieIfapmeFichierGridDto
     */
    idanneeFormationSuivieIfapmeFichier?: number;
    /**
     * 
     * @type {number}
     * @memberof AnneeFormationSuivieIfapmeFichierGridDto
     */
    idtypeAcquisFichier?: number;
    /**
     * 
     * @type {string}
     * @memberof AnneeFormationSuivieIfapmeFichierGridDto
     */
    typeAcquisFichier?: string | null;
    /**
     * 
     * @type {number}
     * @memberof AnneeFormationSuivieIfapmeFichierGridDto
     */
    idfichier?: number | null;
    /**
     * 
     * @type {string}
     * @memberof AnneeFormationSuivieIfapmeFichierGridDto
     */
    fileName?: string | null;
    /**
     * 
     * @type {number}
     * @memberof AnneeFormationSuivieIfapmeFichierGridDto
     */
    uploadUser?: number | null;
    /**
     * 
     * @type {string}
     * @memberof AnneeFormationSuivieIfapmeFichierGridDto
     */
    creationUserName?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof AnneeFormationSuivieIfapmeFichierGridDto
     */
    uploadDate?: Date | null;
}

/**
 * Check if a given object implements the AnneeFormationSuivieIfapmeFichierGridDto interface.
 */
export function instanceOfAnneeFormationSuivieIfapmeFichierGridDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function AnneeFormationSuivieIfapmeFichierGridDtoFromJSON(json: any): AnneeFormationSuivieIfapmeFichierGridDto {
    return AnneeFormationSuivieIfapmeFichierGridDtoFromJSONTyped(json, false);
}

export function AnneeFormationSuivieIfapmeFichierGridDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AnneeFormationSuivieIfapmeFichierGridDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idanneeFormationSuivieIfapmeFichier': !exists(json, 'idanneeFormationSuivieIfapmeFichier') ? undefined : json['idanneeFormationSuivieIfapmeFichier'],
        'idtypeAcquisFichier': !exists(json, 'idtypeAcquisFichier') ? undefined : json['idtypeAcquisFichier'],
        'typeAcquisFichier': !exists(json, 'typeAcquisFichier') ? undefined : json['typeAcquisFichier'],
        'idfichier': !exists(json, 'idfichier') ? undefined : json['idfichier'],
        'fileName': !exists(json, 'fileName') ? undefined : json['fileName'],
        'uploadUser': !exists(json, 'uploadUser') ? undefined : json['uploadUser'],
        'creationUserName': !exists(json, 'creationUserName') ? undefined : json['creationUserName'],
        'uploadDate': !exists(json, 'uploadDate') ? undefined : (json['uploadDate'] === null ? null : new Date(json['uploadDate'])),
    };
}

export function AnneeFormationSuivieIfapmeFichierGridDtoToJSON(value?: AnneeFormationSuivieIfapmeFichierGridDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idanneeFormationSuivieIfapmeFichier': value.idanneeFormationSuivieIfapmeFichier,
        'idtypeAcquisFichier': value.idtypeAcquisFichier,
        'typeAcquisFichier': value.typeAcquisFichier,
        'idfichier': value.idfichier,
        'fileName': value.fileName,
        'uploadUser': value.uploadUser,
        'creationUserName': value.creationUserName,
        'uploadDate': value.uploadDate === undefined ? undefined : (value.uploadDate === null ? null : value.uploadDate.toISOString()),
    };
}

